<template>
    <div>
        <modal ref="modal" @close="goBack()" :content-class="'md:mt-16'">
            <alert ref="alert"></alert>

            <div class="flex flex-col w-full h-full bg-purple-900 overflow-y-auto">
                <div v-if="loading" class="flex w-full h-full items-center justify-center">
                    <div class="loader"></div>
                </div>

                <div v-if="!loading && !checkoutUrl" class="flex flex-col w-full h-full items-center justify-center px-10">
                    <div class="w-full mb-5 md:mb-0 md:mr-5">
                        <input type="text" v-model="documentNumber"
                               class="w-full h-full input"
                               name="document_number" placeholder="CPF / CNPJ">
                    </div>

                    <div class="w-full md:w-1/3">
                        <button class="btn btn-orange w-full" @click="getCheckoutUrl()" :disabled="(!documentNumber || documentNumber.length < 11) || loading">
                            Pagar
                        </button>
                    </div>
                </div>

                <div v-if="!loading && checkoutUrl" class="flex w-full h-full items-center justify-center">
                    <iframe :src="checkoutUrl" frameborder="0" class="w-full h-full"></iframe>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import {Zapin, Auth} from "@/services/Api";

export default {
    props: {
        plan: String
    },

    mounted() {
        this.$refs.modal.open();

        this.loading = true;

        this.loadPlan().then(() => {
            this.loading = false;
            // this.getCheckoutUrl()
            //     .finally(() => this.loading = false);
        });
    },

    data() {
        return {
            planObj: null,
            checkoutUrl: null,
            documentNumber: null,
            loading: false
        }
    },

    methods: {
        loadPlan() {
            return Zapin
                .plans()
                .show(this.plan)
                .then((res) => {
                    this.planObj = res.data;
                })
        },

        getCheckoutUrl() {
            this.loading = true;

            return Zapin
                .payments()
                .paymee()
                .pay(this.planObj.slug, this.documentNumber)
                .then((res) => {
                    this.checkoutUrl = res.data.payment_url;
                })
                .catch(err => {
                    console.log(err);
                    if(err.status === 422) {
                        this.$refs.alert.showValidationErrors(err.data);
                    } else if (err.data.data && err.data.data.message) {
                        this.$refs.alert.show(err.data.data.message);
                    } else {
                        this.$refs.alert.show('Ocorreu um erro desconhecido. Cheque as informações inseridas e se o problema persistir, entre em contato conosco.');
                    }
                })
                .finally(() => this.loading = false);
        },

        goBack() {
            Zapin.updateUserData().finally(() => {
                if(Auth.currentUser().hasSubscription()) {
                    this.$router.push('/');
                } else {
                    history.go(-1);
                }
            })
        }
    }
}
</script>